






























































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import debouce from '../utils/debouce';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class MultipleSelectComponent extends Vue {
  @Prop({ required: false }) labelValue!: string;

  @Prop({ type: Array, default: () => [] }) items!: any[];

  @Prop({ type: Function, required: true }) fetchSearch!: (searchValue: string) => void;

  @Prop({ type: String, default: 'name' }) itemText!: string;

  @Prop({ type: String, default: 'id' }) itemValue!: string;

  @Prop({ type: Boolean, default: false }) loading!: boolean;

  selectedItems: string[] = [];

  searchValue: string = '';

  selectAllCheckbox: boolean = false;

  updateField(field: string, value) {
    this.$emit(`update:${field}`, value);
  }

  sendForm() {
    this.$emit('sendForm');
  }

  @Watch('searchValue')
  async onSearch(val: string) {
    this.searchValue = val;
    if (!val) {
      return;
    }
    debouce.debounce(() => this.fetchSearch(this.searchValue));
  }

  selectAll() {
    this.selectedItems = this.selectAllCheckbox ? [...this.items.map((item) => item.id)] : [];
    this.emitSelected();
  }

  handleChangeCheckBoxValue() {
    const allIds = this.items.map((customer) => customer.id);
    if (!allIds.every((id) => this.selectedItems.includes(id))) {
      this.selectAllCheckbox = false;
      return;
    }
    this.selectAllCheckbox = true;
  }

  emitSelected() {
    this.handleChangeCheckBoxValue()
    this.$emit('selected', this.selectedItems);
  }

  clear() {
    this.selectedItems = [];
    this.selectAllCheckbox = false;
    this.emitSelected();
  }
}
